import NotFound from "../features/errors/NotFound";

const ErrorsPage = () => <NotFound />;

export default ErrorsPage;
